<template lang="pug">
    .model-detail
        gzzoc-eye-detail(v-if="type === 'myopia'")
        gzzoc-congenital-cataract(v-else-if="type === 'congenital_cataract'")
        gzzoc-disease(v-else-if="type === 'ocular_disease'")
        gzzoc-elderly-cataract(v-else-if="type === 'elderly_cataract'")
        gzzoc-eye-pdf(v-else-if="type === 'eyeprint'")
        gzzoc-congenital-cataract-pdf(v-else-if="type === 'ccprint'")
        gzzoc-disease-pdf(v-else-if="type === 'dprint'")
        gzzoc-elderly-cataract-pdf(v-else-if="type === 'ecprint'")
        gzzoc-hepatobiliary(v-else-if="type === 'hepatobiliary_disease'")
        gzzoc-hepatobiliary-pdf(v-else-if="type === 'hprint'")
        GzzocAnemia(v-else-if="type === 'anemia'")
        GzzocFundusImgQuality(v-else-if="type === 'fundus_img_quality'")
        GzzocEyeNeoplasms(v-else-if="type === 'eye_neoplasms'")
        GzzocGlaucoma(v-else-if="type === 'glaucoma'")
        GzzocBlackMole(v-else-if="type === 'pigmented_ocular_surface_tumor'")
        GzzocOcularEmergencyTriage(v-else-if="type === 'ocular_emergency_triage'")
        GzzocCKD(v-else-if="type === 'ckd_screening'")
        GzzocCKD2(v-else-if="type === 'ckd_all'")
        //- gzzoc-hepatobiliary-pdf(v-else-if="type === 'hepatobiliary_disease'")

</template>

<script>
// 中眼
import GzzocEyeDetail from './models/gzzoc-eye';
import GzzocCongenitalCataract from './models/gzzoc-congenital-cataract';
import GzzocDisease from './models/gzzoc-disease';
import GzzocElderlyCataract from './models/gzzoc-elderly-cataract';
import GzzocHepatobiliary from './models/gzzoc-hepatobiliary';
import GzzocEyePdf from './models/gzzoc-eye-pdf.vue';
import GzzocCongenitalCataractPdf from './models/gzzoc-congenital-cataract-pdf';
import GzzocDiseasePdf from './models/gzzoc-disease-pdf';
import GzzocElderlyCataractPdf from './models/gzzoc-elderly-cataract-pdf';
import GzzocHepatobiliaryPdf from './models/gzzoc-hepatobiliary-pdf';
import GzzocAnemia from './models/gzzoc-anemia.vue'
import GzzocFundusImgQuality from './models/gzzoc-fundus-img-quality.vue'
import GzzocEyeNeoplasms from './models/gzzoc-eye-neoplasms.vue'
import GzzocGlaucoma from './models/gzzoc-glaucoma.vue'
import GzzocBlackMole from './models/gzzoc-black-mole';
import GzzocOcularEmergencyTriage from './models/ocular-emergency-triage';
import GzzocCKD from './models/gzzoc-ckd';
import GzzocCKD2 from './models/gzzoc-ckd2';
import { log } from 'three';
export default {
    data () {
        return {
        };
    },
    components: {
        GzzocEyeDetail,
        GzzocCongenitalCataract,
        GzzocDisease,
        GzzocElderlyCataract,
        GzzocHepatobiliary,
        GzzocEyePdf,
        GzzocCongenitalCataractPdf,
        GzzocDiseasePdf,
        GzzocElderlyCataractPdf,
        GzzocHepatobiliaryPdf,
		GzzocAnemia,
		GzzocFundusImgQuality,
        GzzocEyeNeoplasms,
        GzzocGlaucoma,
        GzzocBlackMole,
        GzzocOcularEmergencyTriage,
        GzzocCKD,
        GzzocCKD2
    },
    computed: {
        type () {
            //- console.log(this.$route.params.type);
            return this.$route.params.type;
        }
    },
    created () {
    },
    methods: {

    }
};
</script>

<style lang="sass" scoped>
    .model-detail
        height: 100%
        background: url(~public/images/gzzoc/bg.jpg) no-repeat fixed center top / cover
        overflow: auto
</style>